import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core'
import { CheckoutService } from '../checkout.service'
import { LaunchDialogService } from '@spartacus/storefront'
import { Router } from '@angular/router'
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import { CommonService } from '../../../../../shared/services/common.service'
import { Subscription } from 'rxjs'
import { saveAs } from 'file-saver'
import { ActiveCartFacade } from '@spartacus/cart/base/root'

import { take } from 'rxjs/operators'
import { BreadcrumbService } from '../../../../../shared/components/breadcrumb/breadcrumb.service'
import { VS_LAUNCH_CALLER } from '../../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'vs-order-review',
  templateUrl: './order-review.component.html',
  styleUrls: ['./order-review.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OrderReviewComponent implements OnInit, OnDestroy {
  public vsExportComplianceQuestions
  closeResult: string
  fetchedCartReviewOrder: any = {}
  fetchedSpecialInstructionData: any
  checkSaction: any
  checkCustomer: any
  checkRestrict: any
  checkNuclear: any
  checkCountry: any
  checkPartList: any
  checkWarning: any
  checkLisence: any
  cartId: any
  public getCheckForNuclear
  partialShipping: boolean
  public partialShippingObj
  public pdfDownload
  public getPdf
  public GtsCheck
  public hideTrasnportion: boolean
  isLoggedinUser = false
  public userType
  isCommissionEligible: boolean = false
  getLegalQues: any
  legalCountry: any
  activeCartIdSubscription: Subscription
  orderStatus: boolean = false
  orderCartLabel
  orderCheckoutLabel
  constructor(
    public activeCartService: ActiveCartFacade,
    private checkoutService: CheckoutService,
    private launchDialogService: LaunchDialogService,
    private router: Router,
    private globalMessageService: GlobalMessageService,
    private breadCrumbService: BreadcrumbService,
    private commonService: CommonService,
    private translate: TranslationService,
    private auth: AuthService
  ) {
    this.vsExportComplianceQuestions = []
    this.hideTrasnportion = false

    this.activeCartIdSubscription = this.activeCartService
      .getActiveCartId()
      .subscribe(
        (success) => {
          if (success) {
            this.cartId = success
            this.checkoutService.getComplianceQues(this.cartId).subscribe(
              (success) => {
                this.vsExportComplianceQuestions =
                  success['vsExportComplianceQuestions']
              },
              (error) => {
                this.globalMessageService.add(
                  error,
                  GlobalMessageType.MSG_TYPE_ERROR,
                  5000
                )
                window.scrollTo(0, 0)
              }
            )
            this.getCartReviewOrder()
            this.getPartialShipping()
            this.checkoutService
              .fetchSpecialInstructionData(this.cartId)
              .subscribe(
                (response) => {
                  this.fetchedSpecialInstructionData = response
                  this.checkoutService.specialInstructionObj.next(
                    this.fetchedSpecialInstructionData
                  )
                },
                (error) => {
                  this.globalMessageService.add(
                    error,
                    GlobalMessageType.MSG_TYPE_ERROR,
                    5000
                  )
                  window.scrollTo(0, 0)
                }
              )
          }
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  ngOnDestroy(): void {
    this.orderReviewFlowEntered = false
    if (this.activeCartIdSubscription) {
      this.activeCartIdSubscription.unsubscribe()
    }
    this.checkoutService.storePlaceOrderStatus.next(false)
  }

  ngOnInit(): void {
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        if (success) {
          this.isLoggedinUser = success
          this.userType = 'current'
        } else {
          this.userType = 'anonymous'
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.translate
      .translate('orderCheckOut.shpCart')
      .subscribe((res: string) => {
        this.orderCartLabel = res
      })

    this.translate
      .translate('orderCheckOut.odrCheckout')
      .subscribe((res: string) => {
        this.orderCheckoutLabel = res
        let breadcrumb = [
          {
            label: this.orderCartLabel,
            link: '/cart',
          },
          {
            label: this.orderCheckoutLabel,
            link: '/cart/checkout',
          },
        ]
        this.breadCrumbService.setBreadCrumbs(breadcrumb)
      })

    this.translate
      .translate('orderCheckOut.odrReview')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )

    this.checkoutService.getComplianceQuesLegal().subscribe(
      (success: any) => {
        this.getLegalQues = success
        this.legalCountry =
          this.getLegalQues?.salesAreaAddress?.country?.isocode
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.checkoutService.recieveNuclear.subscribe(
      (success) => {
        this.getCheckForNuclear = success
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    if (this.getCheckForNuclear) {
      this.globalMessageService.add(
        { key: 'orderCheckOut.orderMightGetDelayed' },
        GlobalMessageType.MSG_TYPE_WARNING,
        10000
      )
    }
    this.checkoutService.recievecartReviewRes.subscribe(
      (success) => {
        this.GtsCheck = success
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    //NonCompliant
    if (this.GtsCheck == 'NonCompliant') {
      this.globalMessageService.add(
        { key: 'orderCheckOut.orderFailedInComplianceCheck' },
        GlobalMessageType.MSG_TYPE_ERROR,
        10000
      )
    }
    // RFC issue
    if (this.GtsCheck == 'GTSRfcIssue') {
      this.globalMessageService.add(
        { key: 'orderCheckOut.gtsError' },
        GlobalMessageType.MSG_TYPE_ERROR,
        10000
      )
    }
  }

  orderReviewFlowEntered: boolean = false

  getCartReviewOrder() {
    this.checkoutService.getCartReviewOrder(this.cartId).subscribe(
      (response) => {
        this.fetchedCartReviewOrder = response
        this.orderReviewFlowEntered = true
        this.fetchedCartReviewOrder.entries.map((entry, index) => {
          if (
            entry?.stockAvailability === false &&
            !entry?.quoteCartEntryType
          ) {
            this.globalMessageService.add(
              {
                key: 'orderCheckOut.itemIndexNotAvailableOnRequestedDate',
                params: { index: parseInt(index + 1) },
              },
              GlobalMessageType.MSG_TYPE_ERROR,
              10000
            )
            this.router.navigate(['cart'])
            return
          }
        })
        this.checkoutService.orderSubmittedStatus.subscribe(
          (orderSubmitted) => {
            if (orderSubmitted && this.orderReviewFlowEntered) {
              if (this.fetchedCartReviewOrder?.entries.length == 0) {
                this.globalMessageService.add(
                  { key: 'orderCheckOut.noEntriesFound' },
                  GlobalMessageType.MSG_TYPE_ERROR,
                  6000
                )
                window.scrollTo(0, 0)
                this.router.navigate(['cart'])
              }
            }
          }
        )

        this.checkoutService.getCartReviewOrderResponse.next(response)

        this.isCommissionEligible =
          this.fetchedCartReviewOrder['isCommissionEligible']

        this.checkSaction = this.fetchedCartReviewOrder.sanctionCheck
        this.checkCustomer = this.fetchedCartReviewOrder.customerReviewCheck
        this.checkRestrict = this.fetchedCartReviewOrder.hasRestrictedUse

        if (this.checkSaction == true) {
          this.globalMessageService.add(
            { key: 'orderCheckOut.cantPlaceOrder' },
            GlobalMessageType.MSG_TYPE_WARNING,
            10000
          )
        }
        if (this.checkCustomer == true) {
          this.globalMessageService.add(
            { key: 'orderCheckOut.cantPlaceOrder' },
            GlobalMessageType.MSG_TYPE_WARNING,
            10000
          )
        }
        if (this.checkRestrict == true) {
          this.globalMessageService.add(
            { key: 'orderCheckOut.cantPlaceOrder' },
            GlobalMessageType.MSG_TYPE_WARNING,
            10000
          )
        }
        this.checkNuclear = this.fetchedCartReviewOrder.isNuclear
        this.checkCountry = this.fetchedCartReviewOrder.restrictedCountryCheck
        this.checkPartList = this.fetchedCartReviewOrder.restrictedPartList
        this.checkWarning = this.fetchedCartReviewOrder.warningFlags
        this.checkLisence = this.fetchedCartReviewOrder.requiresExportLicense

        if (this.fetchedCartReviewOrder?.endUserIndustry !== undefined) {
          var res = this.fetchedCartReviewOrder?.endUserIndustry.toLowerCase()
          if (res.includes('nuclear')) {
            this.globalMessageService.add(
              { key: 'orderCheckOut.orderMightGetDelayed' },
              GlobalMessageType.MSG_TYPE_WARNING,
              10000
            )
          }
        }

        if (this.checkNuclear == true) {
          this.globalMessageService.add(
            { key: 'orderCheckOut.orderMightGetDelayed' },
            GlobalMessageType.MSG_TYPE_WARNING,
            10000
          )
        }
        if (this.checkCountry == true) {
          this.globalMessageService.add(
            { key: 'orderCheckOut.orderMightGetDelayed' },
            GlobalMessageType.MSG_TYPE_WARNING,
            10000
          )
        }
        if (this.checkPartList == true) {
          this.globalMessageService.add(
            { key: 'orderCheckOut.orderMightGetDelayed' },
            GlobalMessageType.MSG_TYPE_WARNING,
            10000
          )
        }
        if (this.checkWarning == true) {
          this.globalMessageService.add(
            { key: 'orderCheckOut.orderMightGetDelayed' },
            GlobalMessageType.MSG_TYPE_WARNING,
            10000
          )
        }
        if (this.checkLisence == true) {
          this.globalMessageService.add(
            { key: 'orderCheckOut.orderMightGetDelayed' },
            GlobalMessageType.MSG_TYPE_WARNING,
            10000
          )
        }
        if (
          this.fetchedCartReviewOrder.freightTermCode == 'Prepay_ADD' ||
          this.fetchedCartReviewOrder.freightTermCode == '0003'
        ) {
          this.hideTrasnportion = true
        }

        this.checkoutService.addressObjData.next(this.fetchedCartReviewOrder)
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  openOrderReviewModal() {
    const componentdata = {
      isAdditionalType: this.fetchedCartReviewOrder.isAdditionalType,
    }

    const orderReviewDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.ORDER_REVIEW,
      undefined,
      undefined,
      componentdata
    )
    if (orderReviewDialog) {
      orderReviewDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose.subscribe((value) => {})
    }

    this.checkoutService.storePlaceOrderStatus.subscribe((data) => {
      this.orderStatus = data
    })
  }

  editCartLink() {
    this.router.navigate(['/cart'])
  }

  checkoutLink() {
    this.router.navigate(['/cart/checkout'])
  }

  printShippingMethod() {
    if (this.partialShipping) {
      return 'Partial'
    } else {
      return 'Complete'
    }
  }

  getPartialShipping() {
    this.checkoutService.getCartReviewOrderResponse.subscribe(
      (response) => {
        this.partialShippingObj = response

        this.partialShipping = this.partialShippingObj?.partialShipping
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  downloadPdf() {
    this.checkoutService.downloadOrderPdf(this.userType, this.cartId).subscribe(
      (res) => {
        if (res !== null && res !== undefined) {
          let fileName = 'OrderReview_' + this.cartId
          const blob = new Blob([res], { type: 'application/pdf' })
          const file = new File([blob], fileName + '.pdf', {
            type: 'application/pdf',
          })
          saveAs(file)
        } else {
          this.globalMessageService.add(
            { key: 'orderCheckOut.pdfNotAvailable' },
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  getCouponDiscout() {
    if (this.fetchedCartReviewOrder?.productCouponDiscount?.value > 0) {
      return this.fetchedCartReviewOrder.productCouponDiscount?.formattedValue
    }
    return this.fetchedCartReviewOrder?.orderDiscounts?.formattedValue
  }
}
